import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './user-select-dialog.component.html',
  styleUrls: ['./user-select-dialog.component.scss'],
})
export class UserSelectDialogComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _dialogRef: MatDialogRef<UserSelectDialogComponent>,
  ) {}

  public ngOnInit(): void {}

  public trackByIndex(index: number): number {
    return index;
  }

  public deleteRequest(index: number): void {
    this.data.splice(index, 1);
    this.data = [...this.data];
  }

  public onSubmit(): void {
    this._dialogRef.close(this.data);
  }
}
